import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ApiModel, ListingBuyerModel, ListingBuyerModelConverter } from '@steelbuy/ts-shared';
import axios from '../../axios';
import { getPackageDetails } from '../packages';

interface ListingDetailsOptions<Model> {
    listingId: string;
    queryOptions?: Omit<UseQueryOptions<Model, unknown, Model, string[]>, 'queryFn' | 'queryKey'>;
}

const modelConverter = new ListingBuyerModelConverter();

export const LISTING_SEARCH_KEY = 'listing-search';

export const fetchDetails = async (id: string, isPackage?: boolean, queryParams?: Record<string, unknown>) => {
    if (isPackage) {
        const packageModel = await getPackageDetails(id);
        return packageModel;
    }
    const { data } = await axios.get(`/api/universal/search-listings/${id}`, { params: queryParams });
    const listingModel = modelConverter.toViewModel(data as unknown as ApiModel<ListingBuyerModel>);
    return listingModel;
};

export const useFetchDynamicDeliveryPrice = ({ listingId, queryOptions }: ListingDetailsOptions<ListingBuyerModel>) =>
    useQuery({
        queryKey: [LISTING_SEARCH_KEY, listingId],
        queryFn: () => fetchDetails(listingId, false, { getDeliveryEstimate: true }) as unknown as ListingBuyerModel,
        ...queryOptions,
    });
